import React, { useMemo } from 'react';
import SubbundleLeft from './SubbundleLeft';
import { Package } from 'utils/api/models/numbers/usage';
import { translate } from 'components/Translation';
import moment from 'moment';

interface ISinglePackageProps {
	singlePackage: Package;
}

const SinglePackage = ({ singlePackage }: ISinglePackageProps) => {
	const roamingType = singlePackage.commerceAttributes?.roamingType;
	const productType = singlePackage.commerceAttributes?.productType;
	const isJawazak = productType === 'JAWAZAK';
	const isInternationalMinutes = productType === 'INT_MIN';

	const header = useMemo(() => {
		if (isJawazak) {
			return translate('number.services.mobile.jawazak.roaming');
		}
		if (isInternationalMinutes) {
			return translate('services.gsm.international.minutes');
		}
		return singlePackage.name;
	}, [singlePackage, isJawazak, isInternationalMinutes]);

	const subheader = useMemo(() => {
		if (isJawazak) {
			const type = roamingType === 'JAWAZAK WORLD' ? 'world' : 'gcc';
			const duration = singlePackage.commerceAttributes.duration;
			const packageSize = singlePackage.packageSize;
			return duration > 1
				? translate(
						`number.services.jawazak.${type}.package.name.days`,
						packageSize.value,
						packageSize.unit,
						duration
				  )
				: translate(`number.services.jawazak.${type}.package.name`, packageSize.value, packageSize.unit);
		}
		if (isInternationalMinutes) {
			const autorenewal: boolean = singlePackage.commerceAttributes?.autorenewal;
			return autorenewal ? translate('usage.monthly.renewable') : translate('usage.one.time');
		}
		return '';
	}, [singlePackage, isJawazak, roamingType, isInternationalMinutes]);

	const message = useMemo(() => {
		const validTo = moment(singlePackage.validTo).format('DD.MM.YYYY, HH:mm A');
		const autorenewal: boolean = singlePackage.commerceAttributes?.autorenewal;
		if (isJawazak || (isInternationalMinutes && !autorenewal)) {
			return translate('usage.valid.till', validTo);
		}
		return '';
	}, [singlePackage, isJawazak, isInternationalMinutes]);

	return <SubbundleLeft header={header} subheader={subheader} data={singlePackage} message={message} />;
};

export default SinglePackage;
